import gql from "graphql-tag"

export const DASHBOARD_PAGE = gql`query dashboardPage {
    dashboardPage {
        languageList
        dictList
        translations{lang, keyId, key, value, id}
    }
}`
export const APPROVE_TRANSLATION = gql` mutation approveTranslation($lang: String!, $keyId: Int!, $translationId: Int!) {
    approveTranslation(lang: $lang, keyId: $keyId, translationId: $translationId) {
        id
    }
}`
export const EDIT_TRANSLATION = gql` mutation editTranslation($value: String!, $translationId: Int!) {
    editTranslation(value: $value, translationId: $translationId) {
        id
    }
}`
export const ADD_KEY = gql` mutation addKey($dict: String!, $value: String!, $translations: String) {
    addKey(dict: $dict, value: $value, translations: $translations) {
        id
    }
}`
export const LANGUAGE_STAT = gql` query {
    languageStat {
        totalKeys
        langs {
            lang
            active
        }
    }
}`
export const SIGN_UP = gql` query signup($email: String!, $password: String!, $username: String!) {
    signup(email: $email, password: $password, username: $username) {
        error,
        token
    }
}`
export const SIGN_IN = gql` query signin($email: String!, $password: String!) {
    signin(email: $email, password: $password) {
        error,
        token
    }
}`
export const TRANSLATIONS_PAGE = gql` query translationsPage($lang: String!, $dict: String!, $page: Int!, $searchQuery: String) {
    translationsPage(lang: $lang, dict: $dict, page: $page, searchQuery: $searchQuery) {
        activeTranslations
        totalKeys
        keys {key, id, value, eng}
        dicts {dict, active, total}
        totalPages
        languageList
    }
}`
export const MORE_TRANSLATIONS = gql` query moreTranslations($keyId: Int!, $lang: String!) {
    moreTranslations(keyId: $keyId, lang: $lang) {
        thisLang {id, value, votes, isvoted, active}
        otherLangs {id, lang, value}
    }
}`
export const ADD_TRANSLATION = gql` mutation addTranslation($lang: String!, $keyId: Int!, $translation: String!) {
    addTranslation(lang: $lang, keyId: $keyId, translation: $translation) {
        id
    }
}`
export const VOTE_TRANSLATION = gql` mutation voteTranslation($lang: String!, $keyId: Int!, $translationId: Int!) {
    voteTranslation(lang: $lang, keyId: $keyId, translationId: $translationId) {
        id
    }
}`
export const DELETE_TRANSLATION = gql` mutation deleteTranslation($translationId: Int!) {
    deleteTranslation(translationId: $translationId) {
        id
    }
}`
export const DELETE_KEY = gql` mutation deleteKey($keyId: Int!) {
    deleteKey(keyId: $keyId) {
        id
    }
}`
